import Block from 'models/block';
import Chaplin from 'chaplin';

const BlocksCollection = Chaplin.Collection.extend({
  model: Block,
});

export default BlocksCollection;
